import styled from 'styled-components';

export const CellListInlineGroup = styled.div({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  flexWrap: 'nowrap',
  overflow: 'hidden',
  width: '100%',

  // Container query setup
  containerType: 'inline-size',
  containerName: 'badge-container',
});

export const CellListBadge = styled.div((p) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  backgroundColor: p.$bg ?? 'var(--ds-bg-secondary)',
  borderRadius: 3,
  padding: '2px 6px',
  height: 24,
  flex: '0 0 auto',
  whiteSpace: 'nowrap',

  // Container query: masquer le texte si pas assez de place
  '@container badge-container (max-width: 120px)': {
    '& .badge-text': {
      display: 'none',
    },
    gap: 0,
    padding: '4px',
    width: 24,
    justifyContent: 'center',
  },

  // Pour les très petits espaces, garde juste l'icône
  '@container badge-container (max-width: 80px)': {
    '&:not(:first-child)': {
      display: 'none',
    },
  },
}));

export const CellListBadgeIcon = styled.div(({ $color, $icon }) => ({
  width: 16,
  height: 16,
  backgroundColor: $color || 'var(--ds-icon-base)',
  maskImage: `url('${$icon ?? '/img/alert.svg'}')`,
  WebkitMaskImage: `url('${$icon ?? '/img/alert.svg'}')`,
  maskRepeat: 'no-repeat',
  WebkitMaskRepeat: 'no-repeat',
  maskPosition: 'center',
  WebkitMaskPosition: 'center',
  maskSize: '16px 16px',
  WebkitMaskSize: '16px 16px',
  flex: '0 0 16px',
}));

export const CellListBadgeText = styled.span({
  color: 'var(--ds-text-base)',
  fontFamily: 'proxima-nova',
  fontSize: 12,
  fontWeight: '500',
  lineHeight: '16px',
  whiteSpace: 'nowrap',
});

export const CellListContainer = styled.div((p) => ({
  display: 'inline-flex',
  alignItems: 'center',
  height: 28,
  flex: '0 0 auto',
  flexShrink: 0, // <-- empêche le chip de se compresser
  gap: 0,
  marginRight: 6,

  containerType: 'inline-size',
  containerName: 'cell',

  '&::before': {
    content: '""',
    display: 'none',
    color: '#888',
    fontWeight: 'bold',
    fontSize: 12,
    marginRight: 4,
  },

  '@container cell (min-width: 150px)': {
    '&::before': {
      content: p.$isStacked && !p.$asChip ? `"${p.$label} "` : '""',
      display: 'inline',
    },
  },
}));

export const CellListContent = styled.div((p) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  backgroundColor:
    p.$bg ?? (p.$isStacked ? 'var(--ds-bg-base)' : 'var(--ds-bg-secondary)'),
  borderRadius: 3,
  padding: '4px 6px',
  height: 24,
  width: p.$grow ? '100%' : 'auto',
  maxWidth: p.$grow ? 'none' : 220,
  whiteSpace: 'nowrap',
  flexShrink: 0,
}));

export const CellListInlineItem = styled.span((p) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  backgroundColor: p.$bg ?? 'var(--ds-bg-secondary)', // bg par item
  borderRadius: 3,
  padding: '2px 6px',
  height: 24,
  lineHeight: '16px',
  flex: '0 0 auto',
  whiteSpace: 'nowrap',
}));

export const CellListIcon = styled.div(({ $color, $icon }) => ({
  width: 16,
  height: 16,
  backgroundColor: $color || 'var(--ds-icon-base)',
  maskImage: `url('${$icon ?? '/img/alert.svg'}')`,
  WebkitMaskImage: `url('${$icon ?? '/img/alert.svg'}')`,
  maskRepeat: 'no-repeat',
  WebkitMaskRepeat: 'no-repeat',
  maskPosition: 'center',
  WebkitMaskPosition: 'center',
  maskSize: '16px 16px',
  WebkitMaskSize: '16px 16px',
  flex: '0 0 16px',
}));

export const CellListText = styled.div((p) => ({
  color: 'var(--ds-text-base)',
  display: 'inline-flex',
  fontFamily: 'proxima-nova',
  fontSize: 12,
  fontWeight: '500',
  lineHeight: '16px',

  // pour s'étirer proprement
  whiteSpace: 'nowrap',
  flex: '0 0 auto',
  overflow: 'visible',
}));

export const CellListCaret = styled.span({
  fontSize: '8px',
  marginLeft: '4px',
  marginRight: '4px',
  color: 'var(--ds-text-base)',
  cursor: 'pointer',
  userSelect: 'none',
  opacity: 1,
  lineHeight: '16px',
});
